import { useState } from "react";
import { MessageCircle, X } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";

export const WhatsAppSendDialog = ({ quote, onClose }) => {
  const [phone, setPhone] = useState(quote.customer_phone || "");
  const [error, setError] = useState("");

  const openWhatsApp = () => {
    const digits = phone.replace(/\D/g, "");
    const normalized = digits.startsWith("0") ? `90${digits.slice(1)}` : digits;
    if (normalized.length < 10 || normalized.length > 15) {
      setError("Telefon numarasını ülke koduyla girin. Örnek: 905321234567");
      return;
    }

    const link = `${window.location.origin}/quote/public/${encodeURIComponent(quote.ref_code)}`;
    const message = `Merhaba ${quote.customer_name || ""},\n\n${quote.ref_code} numaralı teklifinizi aşağıdaki bağlantıdan inceleyebilir ve PDF olarak indirebilirsiniz:\n${link}\n\nCDS Teknoloji`;
    window.open(`https://wa.me/${normalized}?text=${encodeURIComponent(message)}`, "_blank", "noopener,noreferrer");
    onClose();
  };

  return <Dialog open onOpenChange={open => { if (!open) onClose(); }}>
    <DialogContent className="whatsapp-dialog" data-testid="whatsapp-send-dialog">
      <DialogHeader>
        <DialogTitle>WhatsApp ile teklif paylaş</DialogTitle>
        <DialogDescription>{quote.ref_code} · {quote.customer_name}</DialogDescription>
      </DialogHeader>
      <p>Müşterinin WhatsApp sohbeti teklif bağlantısıyla açılacak. Mesajı kontrol edip Gönder’e basın. Müşteri bağlantıdan PDF’yi indirebilir.</p>
      <div className="settings-grid">
        <label className="full-field">Alıcı telefonu
          <input type="tel" placeholder="0532 123 45 67" value={phone} onChange={e => { setPhone(e.target.value); setError(""); }} />
        </label>
      </div>
      {error && <p className="integration-error" role="alert">{error}</p>}
      <div className="settings-actions">
        <button className="outline-button" onClick={onClose}><X size={14} />Vazgeç</button>
        <button className="primary-button" onClick={openWhatsApp}><MessageCircle size={16} />WhatsApp’ta aç</button>
      </div>
    </DialogContent>
  </Dialog>;
};
